var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history"},[_c('h2',{staticClass:"history__title"},[_vm._v(_vm._s(_vm.getTranslatedText('history')))]),_c('p',{staticClass:"count"},[_vm._v(_vm._s(_vm.getTranslatedText(`Last ${_vm.countTicket} ticket`)))]),_c('HistoryTransaction',{attrs:{"limit":_vm.countTicket}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }